import {useMemo} from "react";

import {useQuery} from "@tanstack/react-query";
import {useLocation} from "react-router-dom";

import {ResponseError} from "@globals/types/utilityTypes";

import {fetchDishDetails} from "../DishDetailsService";
import {DishDetailsItem, DishDetailsResource} from "../interfaces";
import parseDishUrl from "../utils/parseDishUrl";

export default function useDishDetails(): DishDetailsResource {
  const location = useLocation();

  const [isUrlValid, operatorSlug, slug] = useMemo(
    () => parseDishUrl(location),
    [location]
  );

  const {data, isError, isPending, error} = useQuery<
    DishDetailsItem,
    ResponseError
  >({
    queryKey: ["dish"],
    queryFn: () => fetchDishDetails(operatorSlug, slug),
    enabled: isUrlValid,
  });

  return {
    dish: data,
    isError: !isUrlValid || isError,
    isLoading: isPending,
    error: isUrlValid
      ? error
      : ({
          message: `Sorry! It seems like the URL you used isn't valid.`,
        } as ResponseError),
  };
}
